import { ReactNode } from 'react';
import { HiChevronDown } from 'react-icons/hi';

type Props = {
  label: string;
  labelClass?: string;
  wrapperClass?: string;
  childrenWrapperClass?: string;
  isCollapsed: boolean;
  collapseHandler: () => void;
  children: ReactNode;
};

const Accordion = ({
  label,
  labelClass,
  wrapperClass,
  childrenWrapperClass,
  isCollapsed,
  collapseHandler,
  children
}: Props) => {
  return (
    <div>
      <div className='bg-white rounded-lg'>
				<button
					className={wrapperClass ? wrapperClass : 'relative w-full p-4'}
					onClick={collapseHandler}
				>
					<h1 className={labelClass ? labelClass : "text-lg md:text-xl lg:text-2xl font-bold text-left"}>{label}</h1>
					<HiChevronDown
						className={`absolute h-full top-0 right-4 rotate-270 duration-300 transition-all ease-linear ${
							!isCollapsed && 'rotate-180 duration-300 transition-all ease-linear'
						}`}
						size={30}
					/>
				</button>
			</div>

      {!isCollapsed ? 
        <div className={childrenWrapperClass}>
          {children}
        </div>
      : null }
    </div>
  )
}

export default Accordion